import type { ToastOffset, ToastPosition } from "@fluentui/react-components";

export const TOAST_POSITION: ToastPosition = "top";
export const TOAST_TIMEOUT = 3000;
export const TOAST_OFFSET: ToastOffset = { horizontal: 0, vertical: 10 };
export const TOASTER_ID = "toaster-top";
